import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "III. Occupation 職業", -1)
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4" }
const _hoisted_4 = { class: "space-y-3 col-span-full lg:col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-800" }, "1. Job description/仕事内容", -1)
const _hoisted_6 = { class: "space-y-3 col-span-full lg:col-span-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-800" }, "2. Work hours / 労働時間", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_9 = { class: "grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_10 = { class: "col-span-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-darkgray-800" }, "We will send your results via email to your registered email address. Please check below if you also wish to obtain a hard copy. / 健診結果はご登録いただいているメールアドレスにお送りいたします。ハードコピーをご希望の場合は、以下よりお選びください。", -1)
const _hoisted_12 = { class: "grid grid-cols-1 space-y-2 lg:grid-cols-12" }

import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import { numberonly } from '@/helpers/NumberHelper'
import { ref } from 'vue';
import { onKeypressNumbersOnly, onPasteNumbersOnly } from '@/helpers/ValidationHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'OccupationForm',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(TextInput, {
          modelValue: item.value.job_title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.job_title) = $event)),
          id: "job-title",
          type: "text",
          placeholder: "Job description/仕事内容",
          disabled: __props.disableInputs,
          error: __props.errors['occupation.job_title'] ? __props.errors['occupation.job_title'][0] : ''
        }, null, 8, ["modelValue", "disabled", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(TextInput, {
          id: "days_per_week",
          type: "text",
          placeholder: "Days per week / 週の勤務日数",
          disabled: __props.disableInputs,
          onKeypress: _unref(onKeypressNumbersOnly),
          onPaste: _unref(onPasteNumbersOnly),
          modelValue: item.value.days_per_week,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.days_per_week) = $event)),
          maxlength: 3,
          error: __props.errors['occupation.days_per_week'] ? __props.errors['occupation.days_per_week'][0] : ''
        }, null, 8, ["disabled", "onKeypress", "onPaste", "modelValue", "error"]),
        _createVNode(TextInput, {
          modelValue: item.value.hours_per_day,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.hours_per_day) = $event)),
          id: "work-hours",
          type: "text",
          placeholder: "Hours per day / 1日の勤務時間",
          onKeypress: _unref(onKeypressNumbersOnly),
          onPaste: _unref(onPasteNumbersOnly),
          disabled: __props.disableInputs,
          maxlength: 3,
          error: __props.errors['occupation.hours_per_day'] ? __props.errors['occupation.hours_per_day'][0] : ''
        }, null, 8, ["modelValue", "onKeypress", "onPaste", "disabled", "error"])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(RadioGroup, {
            options: [
                            { id: 'pick_up', label: 'Pick-up/来院', value: 'pick_up'},
                            { id: 'delivery', label: 'Delivery/配送', value: 'delivery'},
                        ],
            name: "result_delivery_option",
            customClass: "col-span-6",
            "is-disabled": __props.disableInputs,
            modelValue: item.value.result_delivery_option,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.result_delivery_option) = $event)),
            error: __props.errors['occupation.result_delivery_option'] ? __props.errors['occupation.result_delivery_option'][0] : ''
          }, null, 8, ["is-disabled", "modelValue", "error"])
        ])
      ])
    ])
  ]))
}
}

})